import { trpc } from "@/util/trpc";

/**
 * @returns an SWR hook to the current user profile.
 *
 * Data is undefined while loading and null if the user is not logged in.
 */
export function useGetLoggedInUser() {
    const query = trpc.edge.users.getLoggedIn.useQuery(undefined, {
        trpc: {
            context: {
                // Always skip batching the request for the user, so it's displayed as fast as possible
                skipBatch: true,
            },
        },
    });

    return {
        ...query,
        user: query.data,
    };
}
